import { render, staticRenderFns } from "./modalAddProduct.vue?vue&type=template&id=6ebb3a2c&"
import script from "./modalAddProduct.vue?vue&type=script&lang=js&"
export * from "./modalAddProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports